import { Button, cn } from "@heroui/react";
import { useResumeBuilder } from "../context";
import { PreviewButton } from "./preview-button";

interface NavigationButtonsProps {
    onBack: () => void;
    onPreview: () => void;
    onNext: () => void;
    nextButtonText?: string;
    showPreviewButton?: boolean;
    disabled?: boolean;
    withBackButton?: boolean;
}

export const NavigationButtons = ({
    onBack,
    onPreview,
    onNext,
    nextButtonText,
    showPreviewButton = true,
    disabled = false,
    withBackButton = true,
}: NavigationButtonsProps) => {
    const { design } = useResumeBuilder();
    return (
        <div className="mt-6 flex w-full flex-col">
            {/* Preview at the top */}
            {showPreviewButton && (
                <div className="mb-4 flex justify-center">
                    <PreviewButton onPreview={onPreview} />
                </div>
            )}
            {/* Navigation at the bottom with Back at left, Next at right */}
            <div
                className={cn(
                    "mt-4 flex justify-between",
                    !withBackButton && "justify-end",
                )}
            >
                {withBackButton && (
                    <Button onPress={onBack} variant="bordered" type="button">
                        ← Zurück
                    </Button>
                )}
                <Button
                    isDisabled={disabled}
                    type="button"
                    onPress={onNext}
                    style={
                        disabled
                            ? undefined
                            : {
                                  backgroundColor: design.resumePrimaryColor,
                                  color: design.resumePrimaryContrastColor,
                              }
                    }
                >
                    {nextButtonText || "Weiter →"}
                </Button>
            </div>
        </div>
    );
};
